import AuthLayoutTemplate from '@/components/ctv/layouts/auth/auth-simple-layout';
import { Toaster } from '@/components/ui/sonner';
import { useCsrfRefresh } from '@/hooks/use-csrf-refresh';

export default function AuthLayout({
  children,
  title,
  description,
  ...props
}: {
  children: React.ReactNode;
  title: string;
  description: string;
  bgImage?: string;
}) {
  // Ensure CSRF token is always up to date
  useCsrfRefresh();

  return (
    <AuthLayoutTemplate title={title} description={description} {...props}>
      {children}
      <Toaster position="top-right" theme="light" richColors />
    </AuthLayoutTemplate>
  );
}
